import { useEffect } from "react";
import confetti from "canvas-confetti";

const SESSION_KEY = "kiro-confetti-shown";

function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/**
 * Fires a single celebratory confetti burst from the centre of the podium
 * area once per browser session. Silent for users with reduced-motion
 * preferences or when the session flag is already set.
 */
export function Confetti() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (prefersReducedMotion()) return;

    try {
      if (window.sessionStorage.getItem(SESSION_KEY) === "1") return;
      window.sessionStorage.setItem(SESSION_KEY, "1");
    } catch {
      // sessionStorage may be blocked (private mode, strict cookies). Skip.
      return;
    }

    // Fire from the horizontal centre, slightly above the fold so the
    // particles fall over the podium.
    confetti({
      particleCount: 18,
      spread: 70,
      startVelocity: 38,
      gravity: 1,
      ticks: 120,
      origin: { x: 0.5, y: 0.35 },
      colors: ["#fbbf24", "#fde68a", "#ec4899", "#c084fc", "#f59e0b"],
      disableForReducedMotion: true,
      scalar: 0.9,
    });
  }, []);

  return null;
}
